import '../../styles/web-components/inventory-level.scss';
const template = `
  <div class="inventory-level__container hidden"></div>
`;
class InventoryLevel extends HTMLElement {
    static get observedAttributes() {
        return ["display", "level"];
    }
    constructor() {
        super();
    }
    connectedCallback() {
        this.innerHTML = template;
        this.el = this.querySelector('.inventory-level__container');
    }
    attributeChangedCallback(name, oldValue, newValue) {
        if (!this.el || oldValue === newValue)
            return;
        switch (name) {
            case 'display':
                this.updateDisplay(newValue);
                break;
            case 'level':
                this.updateLevel(newValue);
                break;
            default:
                break;
        }
    }
    updateDisplay(val) {
        if (val === 'show') {
            this.el.classList.remove('hidden');
        }
        else {
            this.el.classList.add('hidden');
        }
    }
    updateLevel(level) {
        if (!level) {
            this.el.innerHTML = '';
        }
        else {
            this.el.innerHTML = `<span class="inventory-level__indicator inventory-level__indicator--${level}" aria-hidden="true"></span><span class="inventory-level__text">${this.getInventoryLevelText(level)}</span>`;
        }
    }
    getInventoryLevelText(level) {
        return `${window.productUi.inventoryLevels[level]} Online`;
    }
}
if (!window.customElements.get("inventory-level")) {
    customElements.define("inventory-level", InventoryLevel);
}
